/**
 */
class JSONAPI {
    static get version() {
        return 'draft.2';
    }
    /**
     * Close to version of specification we support
     * https://github.com/json-api/json-api/blob/f12d8b0ae6a2cd2c8e769a9620aeb886e7019279/format/index.md
     */
    static parse(response) {
        if (response === undefined || response === null || typeof response !== 'object') {
            return response;
        }
        const linked = {};
        const linkedById = Object.keys(response.linked).reduce((memo1, collectionName) => {
            const out = { ...memo1 };
            out[collectionName] = response.linked[collectionName].reduce((memo2, record) => {
                const indexed = { ...memo2 };
                indexed[record.id] = record;
                return indexed;
            }, {});
            return out;
        }, linked);
        function findMatchingLinkedRecord(collectionName, id) {
            const collection = linkedById[collectionName] || {};
            const record = collection[id];
            return record || { id };
        }
        // given an attribute and an object,
        // pluralize the attribute if the normal form doesn't exist,
        // but the plural form does
        function pluralize(attr, scope) {
            const withS = `${attr}s`;
            if (!scope[attr] && scope[withS]) {
                return withS;
            }
            return attr;
        }
        function parseLink(res, linkObj, linkName, scope, isLinkedScope) {
            const linkParts = linkName.split('.');
            let collectionName = linkParts[0];
            const attr = linkParts[1];
            function appendLinkedRecord(id) {
                const unpacked = findMatchingLinkedRecord(linkObj.type, id);
                if (Array.isArray(this[attr])) {
                    this[attr].push(unpacked);
                }
                else {
                    this[attr] = unpacked;
                }
            }
            // If we're parsing the linked scope,
            // we need to make sure we have the right collection
            if (isLinkedScope) {
                Object.keys(res.links).forEach((name) => {
                    const obj = res.links[name];
                    const nameParts = name.split('.');
                    if (collectionName === nameParts[1]) {
                        const scopedLinked = scope[pluralize(obj.type, scope)][0] || null;
                        if (linked && (attr in scopedLinked || attr in scopedLinked.links)) {
                            collectionName = obj.type;
                        }
                    }
                });
            }
            // Check for pluralized collections
            collectionName = pluralize(collectionName, scope);
            if (scope[collectionName]) {
                scope[collectionName].forEach((item) => {
                    const record = item;
                    record.links = record.links || {};
                    if (record.links[attr]) {
                        if (Array.isArray(record.links[attr])) {
                            record[attr] = [];
                            record.links[attr].forEach((id) => {
                                appendLinkedRecord.call(record, id);
                            });
                        }
                        else {
                            appendLinkedRecord.call(record, record.links[attr]);
                        }
                    }
                });
            }
        }
        // Unpack linked objects before top-level objects
        Object.keys(response.links).forEach((key) => {
            const value = response.links[key];
            parseLink(response, value, key, response.linked, true);
        });
        Object.keys(response.links).forEach((key) => {
            const value = response.links[key];
            parseLink(response, value, key, response, false);
        });
        return response;
    }
}
export default JSONAPI;
